import Login from 'layouts/Auth/Login';

export default Login;
